/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_UnpackedInputs */

const en_cc_unpacked = /** @type {(inputs: Cc_UnpackedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This package is for local unpacked installation in Chrome. It has not been published in the Chrome Web Store.`)
};

const id_cc_unpacked = /** @type {(inputs: Cc_UnpackedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket ini untuk pemasangan lokal sebagai ekstensi unpacked di Chrome. Belum diterbitkan di Chrome Web Store.`)
};

/**
* | output |
* | --- |
* | "This package is for local unpacked installation in Chrome. It has not been published in the Chrome Web Store." |
*
* @param {Cc_UnpackedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_unpacked = /** @type {((inputs?: Cc_UnpackedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_UnpackedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_unpacked(inputs)
	return en_cc_unpacked(inputs)
});